module.exports = __webpack_public_path__ + "img/LLUM_120X35.7f2ebebc.png";